import React from 'react';
import PropTypes from 'prop-types';
import AsyncCallToActions from './AsyncCallToActions';
import css from './CallToActions.scss';
import classNames from 'classnames';
import { noop } from 'Helpers/function';
import lazyLoad from 'Components/asyncLoading/lazyLoad';

const SellerCard = lazyLoad({
    loader: () => import(/* webpackChunkName: "item-seller-cards" */'../SellerCard/SellerCard')
});

export class CallToActionCard extends React.PureComponent {
    static propTypes = {
        onTrack: PropTypes.func,
        itemUserId: PropTypes.string.isRequired,
        userId: PropTypes.string.isRequired,
        itemId: PropTypes.string.isRequired,
        itemStatus: PropTypes.object,
        isMyItem: PropTypes.bool,
        itemValidTo: PropTypes.string,
        toggleFirstTimeUserTips: PropTypes.func,
        phone: PropTypes.string,
        tipsInitiationPoint: PropTypes.string,
        itemUser: PropTypes.object,
        onMessageSend: PropTypes.func,
        categoryId: PropTypes.string,
        leadFormName: PropTypes.string,
        leadFormFlow: PropTypes.func,
        showCall: PropTypes.bool,
        showChat: PropTypes.bool,
        showInterest: PropTypes.bool,
        showCallRequest: PropTypes.bool,
        showWhatsAppCTA: PropTypes.bool,
        showSeePhoneNumber: PropTypes.bool,
        showMakeOffer: PropTypes.bool,
        showTestDrive: PropTypes.bool,
        isShowCoachMark: PropTypes.bool,
        onCloseMarkCoach: PropTypes.func,
        isShowReservationButton: PropTypes.bool,
        isItemReserved: PropTypes.bool,
        escrowTrack: PropTypes.func
    };

    static defaultProps = {
        onTrack: noop,
        itemStatus: {},
        isMyItem: false,
        itemValidTo: '',
        itemUser: {},
        onMessageSend: noop,
        leadFormName: '',
        leadFormFlow: noop,
        showCall: false,
        showChat: false,
        showInterest: false,
        showCallRequest: false,
        showSeePhoneNumber: false,
        showMakeOffer: false,
        showTestDrive: false,
        showWhatsAppCTA: false
    };

    render() {
        return (
            <section
                className={ classNames(
                    css.callToActionCard,
                    (this.props.isMyItem ? css.userIsSeller : '')) }
                data-aut-id="callToActionCard"
            >
                {this.props.userId !== '' && this.props.userId === this.props.itemUserId
                    && <SellerCard
                        itemId={ this.props.itemId }
                        itemValidTo={ this.props.itemValidTo }
                    />
                }
                {this.props.userId !== this.props.itemUserId
                    && <AsyncCallToActions
                        onTrack={ this.props.onTrack }
                        phone={ this.props.phone }
                        categoryId={ this.props.categoryId }
                        userId={ this.props.itemUserId }
                        itemId={ this.props.itemId }
                        itemStatus={ this.props.itemStatus }
                        toggleFirstTimeUserTips={ this.props.toggleFirstTimeUserTips }
                        tipsInitiationPoint={ this.props.tipsInitiationPoint }
                        itemUser={ this.props.itemUser }
                        onMessageSend={ this.props.onMessageSend }
                        leadFormName={ this.props.leadFormName }
                        leadFormFlow={ this.props.leadFormFlow }
                        showTestDrive={ this.props.showTestDrive }
                        showSeePhoneNumber={ this.props.showSeePhoneNumber }
                        showCallRequest={ this.props.showCallRequest }
                        showInterest={ this.props.showInterest }
                        showChat={ this.props.showChat }
                        showCall={ this.props.showCall }
                        showMakeOffer={ this.props.showMakeOffer }
                        isShowCoachMark={ this.props.isShowCoachMark } // props for show coachmark when item enabled escrow & user first time visit adpv
                        onCloseMarkCoach={ this.props.onCloseMarkCoach } // props for show coachmark when item enabled escrow & user first time visit adpv
                        isShowReservationButton={ this.props.isShowReservationButton } // props for show button reservation when item enabled escrow
                        isItemReserved={ this.props.isItemReserved } // disabled button reservation when item is reserved
                        showWhatsAppCTA={ this.props.showWhatsAppCTA }
                        escrowTrack={ this.props.escrowTrack }
                    />
                }
            </section>
        );
    }
}

export default CallToActionCard;
